import { render, staticRenderFns } from "./RevisionsDetails.vue?vue&type=template&id=fed4753e&scoped=true&"
import script from "./RevisionsDetails.vue?vue&type=script&lang=js&"
export * from "./RevisionsDetails.vue?vue&type=script&lang=js&"
import style0 from "./RevisionsDetails.vue?vue&type=style&index=0&id=fed4753e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed4753e",
  null
  
)

export default component.exports